/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Match2pay
 */
export class Match2pay {
    /**
     *
     * @type {string}
     * @memberof Match2pay
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Match2pay
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Match2pay
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof Match2pay
     */
    apiKey: string;
    /**
     *
     * @type {string}
     * @memberof Match2pay
     */
    secretKey: string;
    /**
     *
     * @type {boolean}
     * @memberof Match2pay
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Match2pay
     */
    autoApprove: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Match2pay
     */
    amountFromPsp: boolean;
    /**
     *
     * @type {string}
     * @memberof Match2pay
     */
    host: string;
}
